export default {
    name: 'Vārds',
    tel: 'Telefons',
    save: 'Saglabāt',
    confirm: 'Apstiprināt',
    cancel: 'Atcelt',
    delete: 'Dzēst',
    complete: 'Pabeigt',
    loading: 'Ielādē...',
    telEmpty: 'Lūdzu, ievadiet tālruņa numuru',
    nameEmpty: 'Lūdzu, ievadiet vārdu',
    nameInvalid: 'Nekorekts vārds',
    confirmDelete: 'Vai tiešām vēlaties dzēst?',
    telInvalid: 'Nekorekts tālruņa numurs',
    vanCalendar: {
        end: 'Beigas',
        start: 'Sākums',
        title: 'Kalendārs',
        startEnd: 'Sākums/Beigas',
        weekdays: ['Sv', 'Pr', 'Ot', 'Tr', 'Ce', 'Pk', 'Se'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Izvēlieties ne vairāk kā ${maxRange} dienas`,
    },
    vanCascader: {
        select: 'Izvēlēties',
    },
    vanContactCard: {
        addText: 'Pievienot kontaktinformāciju',
    },
    vanContactList: {
        addText: 'Pievienot jaunu kontaktu',
    },
    vanPagination: {
        prev: 'Iepriekšējais',
        next: 'Nākamais',
    },
    vanPullRefresh: {
        pulling: 'Velciet, lai atsvaidzinātu...',
        loosing: 'Atlaidiet, lai atsvaidzinātu...',
    },
    vanSubmitBar: {
        label: 'Kopā:',
    },
    vanCoupon: {
        unlimited: 'Bez ierobežojumiem',
        discount: (discount) => `${discount * 10}% atlaide`,
        condition: (condition) => `Vismaz ${condition}`,
    },
    vanCouponCell: {
        title: 'Kupons',
        tips: 'Nav kuponu',
        count: (count) => `Jums ir ${count} kupon${count % 10 === 1 && count % 100 !== 11 ? 's' : 'i'}`,
    },
    vanCouponList: {
        empty: 'Nav kuponu',
        exchange: 'Apmainīt',
        close: 'Aizvērt',
        enable: 'Pieejams',
        disabled: 'Nav pieejams',
        placeholder: 'Kupona kods',
    },
    vanAddressEdit: {
        area: 'Rajons',
        postal: 'Pasta indekss',
        areaEmpty: 'Lūdzu, atlasiet piegādes reģionu',
        addressEmpty: 'Adrese nevar būt tukša',
        postalEmpty: 'Nepareizs pasta indekss',
        defaultAddress: 'Iestatīt kā noklusējuma adresi',
        telPlaceholder: 'Telefons',
        namePlaceholder: 'Vārds',
        areaPlaceholder: 'Rajons',
    },
    vanAddressEditDetail: {
        label: 'Adrese',
        placeholder: 'Adrese',
    },
    vanAddressList: {
        add: 'Pievienot jaunu adresi',
    },
};